import React from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

interface IProps {
  name1: string
  street1: string
  city: string
  region: string
  postcode: string
}

const Customer = ({ name1, street1, city, region, postcode }: IProps) => (
  <Grid container direction="column">
    <Grid item>
      <Box my={{ xs: 1 }}>
        <Typography variant="h3" color="secondary">
          {name1}
        </Typography>
      </Box>
      <Box my={{ xs: 1 }}>
        <Typography variant="h4" color="secondary">
          {street1.toUpperCase()}
        </Typography>
      </Box>
      <Box my={{ xs: 1 }}>
        <Typography variant="h4" color="secondary">
          {city.toUpperCase()}
        </Typography>
      </Box>
      <Box my={{ xs: 1 }}>
        <Typography variant="h4" color="secondary">
          {region.toUpperCase()}
        </Typography>
      </Box>
      <Box my={{ xs: 1 }}>
        <Typography variant="h4" color="secondary">
          {postcode}
        </Typography>
      </Box>
    </Grid>
  </Grid>
)

export default Customer
